import NodeLabel from "Areas/SharedFeatures/nodeLabel";
import Button from "Components/button";
import Close from "Components/close";
import RotatedArrow from "Components/rotatedArrow";
import Scrollbars from "Components/scrollbars";
import SlideUpDown from "Components/slideUpDown";
import includes from "lodash/includes";
import map from "lodash/map";
import reject from "lodash/reject";
import React, { useCallback, useMemo, useState } from "react";
import { v4 as uuid } from "uuid";
import { Styled as CommonStyled } from "Areas/Sidebar/Common";
import locale from "./methodsSubMenu.locale";
import Styled from "./methodsSubMenu.styled";
export default function MethodsSubMenu(props) {
    const [closed, setClosed] = useState([]);
    const methodsSubMenuId = useMemo(() => `methodsSubMenu${uuid()}`, []);
    const handleOpenCreateScriptPanel = useCallback(() => {
        props.onOpenCreateScriptPanel &&
            props.onOpenCreateScriptPanel(map(props.selectedMethods, "method"), `#${methodsSubMenuId}`);
    }, [methodsSubMenuId, props.selectedMethods]);
    const style = useMemo(() => ({ height: props.height }), [props.height]);
    const buildHandleDelete = useCallback((method, nodesSource) => (e) => {
        e.stopPropagation();
        props.onSetMethodSelected && props.onSetMethodSelected(method, nodesSource, false);
    }, [props.onSetMethodSelected]);
    return (React.createElement(Styled.SidebarSubMenu, { style: style, id: methodsSubMenuId },
        React.createElement("div", { className: "grid-cols-1fr-auto v-center-items" },
            React.createElement("span", { className: "text-light-on-surface fw-6 font-small" }, locale.HEADER_TITLE),
            React.createElement(Close, { className: "text-light-on-surface mr-0_25", fontSize: 14, onClick: props.onHide })),
        React.createElement(Button, { className: "", onClick: handleOpenCreateScriptPanel, minWidth: 120 }, locale.CREATE_SCRIPT),
        React.createElement(Scrollbars, { extraRightSpace: true },
            React.createElement("div", null, map(props.selectedMethods, item => (React.createElement("div", { key: item.method.Id },
                React.createElement("div", { className: "caption-with-actions-panel v-center-items pt-0_5 pb-0_5 border-bottom clickable", onClick: () => {
                        setClosed(prev => includes(prev, item.method.Id)
                            ? reject(prev, e => e === item.method.Id)
                            : [...prev, item.method.Id]);
                    } },
                    React.createElement("div", { className: "caption-with-actions-panel v-center-items no-gap text-light-on-surface" },
                        React.createElement("div", { className: "text-overflow-ellipsis font-bolder font-small" }, `${item.method.GroupName} / ${item.method.Name}`),
                        React.createElement(RotatedArrow, { className: "text-light-on-surface-variant ml-0_5", open: !includes(closed, item.method.Id), size: 12 })),
                    React.createElement(CommonStyled.TrashIcon, { title: locale.DELETE, onClick: buildHandleDelete(item.method, item.nodesSource) })),
                React.createElement(SlideUpDown, { customWrap: "pb-0_5 pt-0_5", open: !includes(closed, item.method.Id) }, map(item.nodesSource, source => (React.createElement("div", { key: source.NodeId, className: "caption-with-actions-panel v-center-items pb-0_25 pt-0_25" },
                    React.createElement(NodeLabel, { key: source.NodeId, imgSize: 18, data: source, documentObject: props.documentObjects
                            ? props.documentObjects[source.DocumentObjectId]
                            : undefined, className: "v-center-items text-light-on-surface-variant font-small", showDocumentObjectName: false, imgDefaultGrayscale: true }),
                    React.createElement(CommonStyled.TrashIcon, { onClick: () => {
                            props.onSetMethodSelected &&
                                props.onSetMethodSelected(item.method, [source], false);
                        }, title: locale.DELETE })))))))))),
        React.createElement(Button, { onClick: props.onClear },
            React.createElement("i", { className: "icon-rotate-right" }),
            React.createElement("span", { className: "ml-0_5" }, locale.CLEAR))));
}
